import { useCallback, useState } from 'react';

/**
 * 全局通知数据流
 */
export default function useNotificationModel() {
  const [notifications, setNotifications] = useState<
    API.NOTIFICATION.Message[]
  >([]);

  /**
   * 添加新通知
   * @param notification 通知消息
   */
  const addNotification = useCallback(
    (notification: Omit<API.NOTIFICATION.Message, 'key' | 'timestamp'>) => {
      const newNotification: API.NOTIFICATION.Message = {
        ...notification,
        key: `${Date.now()}-${Math.random()}`,
        timestamp: Date.now(),
      };

      setNotifications((prev) => [newNotification, ...prev]);

      return newNotification.key;
    },
    [],
  );

  /**
   * 清除指定通知
   * @param id 通知ID
   */
  const removeNotification = useCallback((id: string) => {
    setNotifications((prev) => prev.filter((n) => n.key !== id));
  }, []);

  /**
   * 清空所有通知
   */
  const clearNotifications = useCallback(() => {
    setNotifications([]);
  }, []);

  return {
    notifications,
    addNotification,
    removeNotification,
    clearNotifications,
  };
}
